import { Grid, IconButton, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { InventoryCountItem } from '../../store/config/types';
import { Delete } from '@material-ui/icons';

interface InventoryCountItemListProps {
  items: InventoryCountItem[];
  displayCounted?: boolean;
  displayExpected?: boolean;
  // eslint-disable-next-line
  handleRemoveItem?: (index: number) => void;
}
export default function InventoryCountItemList({
  items,
  handleRemoveItem,
  displayCounted,
  displayExpected,
}: InventoryCountItemListProps) {
  return (
    <Table>
      <TableHead>
        <TableCell>#</TableCell>
        <TableCell>Product</TableCell>
        <TableCell>Lot ID</TableCell>
        <TableCell>Comments</TableCell>
        {displayCounted && <TableCell>Counted</TableCell>}
        {displayExpected && <TableCell>Expected</TableCell>}
        {handleRemoveItem && <TableCell></TableCell>}
      </TableHead>
      <TableBody>
        {items.map((item, index) => (
          <TableRow key={index}>
            <TableCell>{index + 1}</TableCell>
            <TableCell>
              <Grid container direction="column">
                <Typography variant="caption" color="grayText">
                  {item.product?.externalId}
                </Typography>
                <Typography variant="subtitle1">{item.product?.name}</Typography>
                <Typography variant="caption" color="textSecondary">
                  {item.product?.description}
                </Typography>
              </Grid>
            </TableCell>
            <TableCell>{item.lotId ?? ''}</TableCell>
            <TableCell>{item.comment ?? ''}</TableCell>
            {displayCounted && (
              <TableCell>
                {item.totalQuantityCounted ?? 0}{' '}
                <span style={{ fontSize: '80%' }}>{item.product?.unitOfMeasure ?? ''}</span>
              </TableCell>
            )}
            {displayExpected && <TableCell>{item.totalQuantityExpected}</TableCell>}
            {handleRemoveItem && (
              <TableCell>
                <IconButton onClick={() => handleRemoveItem(index)}>
                  <Delete style={{ color: 'red' }} />
                </IconButton>
              </TableCell>
            )}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
